var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRedDeleteIcon = function SvgRedDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 88,
    viewBox: "0 0 87 88",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4008,
    cy: 44.3267,
    r: 40.4359,
    fill: "#F4A024",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4018,
    cy: 44.3276,
    r: 26.5405,
    fill: "#ED6140",
    stroke: "#C14E0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 40.0865H41.749V50.5865H39.999V40.0865ZM45.249 40.0865H46.999V50.5865H45.249V40.0865Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34.8333V36.5833H34.75V54.0833C34.75 54.5475 34.9344 54.9926 35.2626 55.3208C35.5908 55.649 36.0359 55.8333 36.5 55.8333H50.5C50.9641 55.8333 51.4092 55.649 51.7374 55.3208C52.0656 54.9926 52.25 54.5475 52.25 54.0833V36.5833H54V34.8333H33ZM36.5 54.0833V36.5833H50.5V54.0833H36.5ZM40 31.3333H47V33.0833H40V31.3333Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8402 62.0386L64.8794 59.7324L62.7029 62.9467L64.8794 66.1611L61.8402 63.8549L58.8066 66.1611L60.9832 62.9467L58.8066 59.7324L61.8402 62.0386Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.4381 32.8509C31.3549 29.8234 31.3549 24.9149 28.4381 21.8874C25.5212 18.8599 20.7921 18.8599 17.8752 21.8874C14.9583 24.9149 14.9583 29.8234 17.8752 32.8509C20.7921 35.8784 25.5212 35.8784 28.4381 32.8509Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.7696 32.7385C28.5853 31.5351 29.928 28.1904 28.7686 25.2678C27.6092 22.3453 24.3867 20.9517 21.571 22.1551C18.7553 23.3584 17.4125 26.7032 18.572 29.6257C19.7314 32.5482 22.9539 33.9419 25.7696 32.7385Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.7819 23.1427C23.5445 24.8878 23.7819 27.0659 20.793 27.3381C21.6782 27.7669 22.6671 28.1412 23.2848 29.0016C23.8331 29.768 24.2803 31.0571 24.3734 31.9963C24.5413 30.9836 24.3144 30.0388 24.9177 29.0016C25.1361 28.6191 25.4354 28.2931 25.7931 28.0483C26.1507 27.8035 26.5572 27.6463 26.982 27.5886C26.0259 27.0441 25.1944 27.1257 24.6147 25.9401C24.388 25.4921 24.1997 25.0243 24.0521 24.5421C23.9104 24.0561 23.9603 23.3006 23.6586 22.9453L23.7819 23.1427Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red-delete-icon.afd0e1f5.svg";
export { ForwardRef as ReactComponent };